import BaseHTMLColumnStrategy from './BaseHTMLColumnStrategy'

export default function BSHtmlBaseBillableStrategy() {}

BSHtmlBaseBillableStrategy.prototype = new BaseHTMLColumnStrategy()

BSHtmlBaseBillableStrategy.prototype.getLevelsNumber = function() {
    return 1
}

BSHtmlBaseBillableStrategy.prototype.addSecondHeaderRowCells = function(row, levelsNumber) {
    // do nothing
}


// WEBPACK FOOTER //
// ./web/js/reports/preview/html/billingsummary/BSHtmlBaseBillableStrategy.js